/* ═══════════════════════════════════════════════════════════════════
   Lake Life Designs — Client-side Filter Engine (filter-engine.js)

   How it works:
   - Product cards have data-tags="Cotton|Long Sleeves|T-shirts"
   - Checkboxes have data-group="Shirt Material" and value="Cotton"
   - Checking a box shows/hides cards instantly — no page reload
   - OR logic within a group (Cotton OR Polyester)
   - AND logic across groups (Cotton AND Long Sleeves)
   - Counts never change — they always show the full collection count
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Find all filter checkboxes and product cards ─────────────────── */
  var checkboxes   = document.querySelectorAll('.filter-cb');
  var productCards = document.querySelectorAll('.product-card');
  var countEls     = document.querySelectorAll('.filter-count');

  if (!checkboxes.length || !productCards.length) return;

  /* ── Pre-compute static counts from ALL cards on load ──────────────── */
  /* Counts reflect the full collection, never change when filtering */
  var tagTotals = {};
  productCards.forEach(function (card) {
    var tags = (card.getAttribute('data-tags') || '').split('|');
    tags.forEach(function (tag) {
      tag = tag.trim();
      if (tag) tagTotals[tag] = (tagTotals[tag] || 0) + 1;
    });
  });

  /* Write static counts into the DOM */
  countEls.forEach(function (el) {
    var tag = el.getAttribute('data-tag');
    var n   = tagTotals[tag] || 0;
    el.textContent = '(' + n + ')';
    /* Hide options that have 0 products in this collection */
    if (n === 0) {
      var option = el.closest('.sidebar-option');
      if (option) option.style.display = 'none';
    }
  });

  /* ── Core filter function ─────────────────────────────────────────── */
  function applyFilters() {
    /* Build activeGroups: { "Shirt Material": ["Cotton","Polyester"], ... } */
    var activeGroups = {};
    checkboxes.forEach(function (cb) {
      if (cb.checked) {
        var group = cb.getAttribute('data-group');
        if (!activeGroups[group]) activeGroups[group] = [];
        activeGroups[group].push(cb.value);
      }
    });

    var hasActiveFilters = Object.keys(activeGroups).length > 0;

    /* Show/hide each product card */
    var visibleCount = 0;
    productCards.forEach(function (card) {
      var cardTags = (card.getAttribute('data-tags') || '').split('|').map(function(t){ return t.trim(); });
      var show = true;

      if (hasActiveFilters) {
        /* For each group with active selections, product must match >= 1 tag (OR within group) */
        /* All groups must match (AND across groups) */
        Object.keys(activeGroups).forEach(function (group) {
          var groupTags = activeGroups[group];
          var matchesGroup = groupTags.some(function (gt) {
            return cardTags.indexOf(gt) !== -1;
          });
          if (!matchesGroup) show = false;
        });
      }

      card.style.display = show ? '' : 'none';
      if (show) visibleCount++;
    });

    /* Update the product count display */
    var countDisplay = document.querySelector('.collection-count');
    if (countDisplay) {
      var total = productCards.length;
      if (hasActiveFilters && visibleCount !== total) {
        countDisplay.textContent = visibleCount + ' of ' + total + ' Products';
      } else {
        countDisplay.textContent = total + ' Products';
      }
    }

    /* Update active filter pills */
    renderActivePills(activeGroups);

    /* Persist state in sessionStorage so it survives soft navigations */
    try {
      sessionStorage.setItem('lld_filters', JSON.stringify(activeGroups));
    } catch(e) {}
  }

  /* ── Active filter pills ──────────────────────────────────────────── */
  function renderActivePills(activeGroups) {
    var pillContainer = document.getElementById('ActiveFilterPills');
    if (!pillContainer) return;
    var pills = [];
    Object.keys(activeGroups).forEach(function (group) {
      activeGroups[group].forEach(function (tag) {
        pills.push(
          '<button class="active-filter-pill" data-group="' + escHtml(group) + '" data-tag="' + escHtml(tag) + '">'
          + escHtml(tag)
          + '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>'
          + '</button>'
        );
      });
    });

    if (pills.length > 0) {
      pillContainer.innerHTML = pills.join('') + '<button class="sidebar-clear-all" id="ClearAllFilters">Clear all</button>';
      pillContainer.style.display = 'flex';
    } else {
      pillContainer.innerHTML = '';
      pillContainer.style.display = 'none';
    }

    /* Remove-pill clicks */
    pillContainer.querySelectorAll('.active-filter-pill').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.getAttribute('data-group');
        var tag   = btn.getAttribute('data-tag');
        checkboxes.forEach(function (cb) {
          if (cb.getAttribute('data-group') === group && cb.value === tag) {
            cb.checked = false;
          }
        });
        applyFilters();
      });
    });

    /* Clear all */
    var clearBtn = document.getElementById('ClearAllFilters');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        checkboxes.forEach(function (cb) { cb.checked = false; });
        applyFilters();
      });
    }
  }

  /* ── Restore filter state from sessionStorage ─────────────────────── */
  try {
    var saved = sessionStorage.getItem('lld_filters');
    if (saved) {
      var savedGroups = JSON.parse(saved);
      checkboxes.forEach(function (cb) {
        var group = cb.getAttribute('data-group');
        var val   = cb.value;
        if (savedGroups[group] && savedGroups[group].indexOf(val) !== -1) {
          cb.checked = true;
        }
      });
    }
  } catch(e) {}

  /* ── Attach change listeners ──────────────────────────────────────── */
  checkboxes.forEach(function (cb) {
    cb.addEventListener('change', applyFilters);
  });

  /* ── Initial run ──────────────────────────────────────────────────── */
  applyFilters();

  /* ── Utility ──────────────────────────────────────────────────────── */
  function escHtml(s) {
    return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

})();
